<template lang="pug">

    div
        .inline.fields

            .field(v-for="valueModel in field.values")
                .ui.radio.checkbox
                    input(
                        type="radio"
                        v-bind:id="valueModel.id"
                        v-bind:name="field.id"
                        v-bind:value="valueModel.value"
                        v-on:input="updateValue(valueModel.value)"
                    )
                    label(v-bind:for="valueModel.id") {{ valueModel.value }}

            error(:$v='$v.value' validator='required')
                | Darf nicht leer sein. Bitte einen Wert auswählen


        dynamic-field(
            v-for='childrenFieldModel in directChildrenFieldModels'
            v-bind:key='childrenFieldModel.id'
            v-if="isVisible(childrenFieldModel)"
            v-bind:field="childrenFieldModel"
            v-bind:field-models="fieldModels"
            v-bind:value="value"
            v-on:input="forwardPatch"
        )


</template>

<script>
    import isEmpty from 'lodash/isEmpty'
    import * as R from "ramda";
    import { get_level, get_elements_by_level } from "@/utils/form"
    import Error from '@/components/form/FieldError.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: {
            dynamicField: () => import('@/components/products/forms/variant-forms/form/DynamicField'),
            Error
        },

        computed: {

            childrenFieldModels() {
                // Alle Felder filter, die mit der ID dieses Feldes beginnen
                // > [ { id: "foo-1-1" }, { id: "foo-1-1-1" }, { id: "foo-1-1-2" }, { id: "foo-1-1-2-1" }, { id: "foo-1-2" } ]
                // < [ { id: "foo-1-1-1" }, { id: "foo-1-1-2" }, { id: "foo-1-1-2-1" } ]
                return R.filter(field => R.startsWith(`${this.field.id}-`, field.id), this.fieldModels)
            },

            directChildrenFieldModels() {
                // Level dieses Feldes ermitteln
                const currentLevel = get_level(this.field.id)

                // Felder des übernächsten (das nächste Level sind keiner FieldModels, sondern ValueModels) Levels holen
                // > [ { id: "foo-1-1-1" }, { id: "foo-1-1-2" }, { id: "foo-1-1-2-1" } ]
                // < [ { id: "foo-1-1-2-1" } ]
                return get_elements_by_level(currentLevel+2, this.childrenFieldModels)
            },


            $invalid() {
                return this.$v.$invalid
            }
        },


        methods: {

            $touch() {
                this.$v.$touch()
            },

            forwardPatch(patch) {
                this.$emit("input", patch)
            },

            isVisible(childFieldModel) {
                // Aktuell ausgewählten Wert holen
                // > { "foo-1-1-1": "bar-1-1-1", "foo-1-2-1": "bar-1-2-1" }
                // < "bar-1-1-1"
                const selectedValue = R.prop(this.field.id, this.value)


                // ID des ausgewählten Wertes ermitteln
                const selectedId = R.compose(

                    // ID zurueckgeben oder leeren String
                    // > [ { id: "foo-1-1-1", value: "bar-1-1-1" } ]
                    // < "foo-1-1-1"
                    R.propOr("", "id"),

                    // In ValueModels nach aktuellen Wert suchen
                    // > [ { id: "foo-1-1-1", value: "bar-1-1-1" }, { id: "foo-1-1-2", value: "bar-1-1-2" } ]
                    // < [ { id: "foo-1-1-1", value: "bar-1-1-1" } ]
                    R.find(R.propEq("value", selectedValue))

                )(this.field.values)

                // Pruefen ob ID ermitteln werden konnte (also ein Wert ausgewählt ist)
                if (R.length(selectedId) === 0) {
                    return false
                }

                // Pruefen ob childFieldModel Kind von aktuell ausgewählten Wert ist
                return R.startsWith(selectedId, childFieldModel.id)
            },

            preparePatch() {
                return R.compose(

                    // Annderung mitteilen
                    // patch => this.$emit('input', patch),

                    // Wieder zu Objekt umwandeln
                    // > [ [ "form-1-1", 1 ] ]
                    // < { form-1-1: 1 }
                    R.fromPairs,

                    // Wert und "Kindswerte entfernen
                    // > [ [ "form-1-1", 1 ], [ "form-1-2", 2 ], [ "form-1-2-1", 3 ] ]
                    // < [ [ "form-1-1", 1 ] ]
                    R.reject(pair => R.startsWith(this.field.id, pair[0])),

                    // Value-Objekt in Tupel umwandeln
                    // > { form-1-1: 1, form-1-2: 2, form-1-2-1: 3 }
                    // < [ [ "form-1-1", 1 ], [ "form-1-2", 2 ], [ "form-1-2-1", 3 ] ]
                    R.toPairs

                )(this.value)
            },

            updateValue(value) {
                const patch = this.preparePatch()
                this.$emit("input", R.assoc(this.field.id, value, patch))
            }

        },

        props: {

            field: {
                type: Object,
                required: true
            },

            fieldModels: {
                type: Array,
                required: true
            },

            value: {
                required: true
            }

        },

        validations: {
            value: {
                required: (value, vm) => {
                    if (vm.field.required === false) {
                        return true
                    }

                    return !isEmpty(value[vm.field.id])
                }
            },
        },

    }

</script>
